import PhotoSwipeLightbox from "./vendor-script-photo-swipe-lightbox.min.js"
import PhotoSwipe from "./vendor-script-photo-swipe.min.js"

class LightBox {
	constructor(element) {
		this.gallery = element
		this.galleryImages = this.gallery.querySelectorAll('img')

		this.prepareGallery()
		this.init()
	}

	init() {
		this.lightBox = new PhotoSwipeLightbox(this.getSettings())
		this.lightBox.init()
	}

	getSettings() {
		return {
			gallery: this.gallery,
			children: "a",
			mouseMovePan: true,
			initialZoomLevel: "fit",
			secondaryZoomLevel: 1.5,
			maxZoomLevel: 1,
			showHideAnimationType: "none",
			pswpModule: PhotoSwipe
		}
	}

	prepareGallery() {
		this.galleryImages.forEach(galleryImage => {
			if (!galleryImage.parentElement.hasAttribute("href") && galleryImage.hasAttribute("src")) {
				const link = document.createElement("a")
				link.setAttribute("href", galleryImage.src.split('&')[0])
				link.setAttribute("data-pswp-width", "1170")
				link.setAttribute("data-pswp-height", "1170")
				link.setAttribute("target", "_blank")
				link.append(galleryImage.cloneNode(true))
				galleryImage.replaceWith(link)
			}
		})
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const productGalleryElement = document.querySelector(".product-gallery_preview-container")
	if (productGalleryElement) {
		new LightBox(productGalleryElement)
	}

	const productDescriptionElement = document.querySelector(".product-description")
	if (productDescriptionElement) {
		const productDescriptionGalleryElements = productDescriptionElement.querySelectorAll("figure")

		productDescriptionGalleryElements.forEach(productDescriptionGalleryElement => {
			new LightBox(productDescriptionGalleryElement)
		})
	}
})
